<script lang="ts">
  export let pwtData: any;
  export let width: number;
  export let height: number;

  import P5 from 'p5-svelte';
  import PwtsLib from '@ludans/murano-fantasy';

  let rendering = true;

  const sketch = (p) => {

    let qrCodeDiv;

    p.setup = () => {
      p.createCanvas(width, height);
      p.noLoop();

      qrCodeDiv = p.createDiv();
      qrCodeDiv.position(0, 0);
    };

    p.draw = () => {
      //let start = p.millis();
      const aPwt = PwtsLib.drawPwt(p, pwtData, width, height, {});

      PwtsLib.setCurrentPwtForZoom(p, aPwt, {
        mouseMove: true,
        activateQrCode: false,
      });
      //let end = p.millis();
      //let elapsed = end - start;
      //console.log('pwt large draw', elapsed);
      rendering = false;
    };

  };
</script>

<span aria-busy={rendering}>
  <P5 {sketch} />
</span>
